// 下拉单选
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import "./index.less";
import { Select, Space } from 'antd';
import { language } from "@/utils/language"; 
const DropdownRadio = ({ info, answer, changeAnswer }) => {
  const items = get(info, "options", []);
  const [area, setArea] = useState(() =>
    answer[info.id] ? Object.keys(answer[info.id])?.[0] : null
  );

  useEffect(() => {
    // 默认选中
    try {
      const a = answer[info.id];
      const k = Object.keys(a)[0];
      setArea(a ? k : null);
    } catch (error) { }
  }, [answer]);

  return (
    <div className="dropdown-radio">

      <Select
       value={area || undefined}
      onChange={(e) => {
        setArea(e);
        if (e == '') {
          changeAnswer({});
          return
        }
        changeAnswer({ [e]: null });
      }}
        // defaultValue="lucy"
        placeholder={language().select_answer}
      >
         {items
          .filter((item) => item.hide === 0 || item.hide === null)
          .map((item) => (
            <Select.Option value={item.id} key={item.id} >
            <span dangerouslySetInnerHTML={{__html:item.description}}></span>
          </Select.Option>
          ))}
      </Select>
      
    </div>
  );
};

export default DropdownRadio;
